import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  Slide,
  Typography,
  Button,
  Grid,
} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";

import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import {
  GET_ORDERS_STORE,
  GET_ORDERS_DETAILS,
  GET_STATES_ORDER,
  GET_STATES,
  GET_ORDERS_PENDING,
} from "../../../constants";
import AdminContext from "../../../context/admin/AdminContext";
import { Axios } from "../../../config/axios";
import { useReactToPrint } from "react-to-print";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import moment from "moment";
import Print from "./Print";
import { calcularTotal } from "../../../utils/total";
import UpdateOutlinedIcon from "@material-ui/icons/UpdateOutlined";
import Select from "react-dropdown-select";
import toast from "toasted-notes";
import { buildDetail } from "../../../utils/orders";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export const Orders = ({ count }) => {
  const { admin } = React.useContext(AdminContext);
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [details, setDetails] = useState([]);
  const [pedido, setPedido] = useState("");
  const [total, setTotal] = useState(0);
  const [states, setStates] = useState([]);
  const [state, setState] = useState("");

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    getOrders();    
  }, [count]);

  const getStates = async (Estado) => {
    Axios.get(`${GET_STATES_ORDER}${Estado}`)
      .then((res) => {
        console.log(res.data);
        //setLoading(false);
        setStates(res.data);
        setState(res.data.find((s) => s.Codigo == Estado));
      })
      .catch((err) => {
        //setLoading(false);
        console.log(err);
      });
  };

  const getOrders = async () => {
    Axios.get(`${GET_ORDERS_PENDING}${admin.codigo}`)
      .then((res) => {
        console.log(res.data);
        //setLoading(false);
        setOrders(res.data);
      })
      .catch((err) => {
        //setLoading(false);
        console.log(err);
      });
  };

  const getOrdersDetails = async (item) => {
    Axios.get(`${GET_ORDERS_DETAILS}${item.NumeroPedido}`)
      .then((res) => {
        console.log(res.data);
        //setLoading(false);
        setDetails(res.data);
        getStates(item.Estado);
        setPedido(item);
        setTotal(calcularTotal(res.data));
        setOpen(true);
      })
      .catch((err) => {
        //setLoading(false);
        console.log(err);
      });
  };

  const changeState = (item) => {
    if(parseInt(item.Codigo)===pedido.Estado){
      return
    }
    let data;
    if (item.Codigo == 1) {
      let Detalle = buildDetail(details);

      data = {
        NumeroPedido: pedido.NumeroPedido,
        Valor: pedido.Valor,
        Observacion: pedido.Observacion,
        Detalle,
      };

      let url = "Pedido/Despachar";
      service(item.Codigo, url, data);
    }
    if (item.Codigo == 4 || item.Codigo == 3) {
      data = {
        CodTienda: admin.codigo,
        Data: ["" + pedido.Id],
        Web: true,
      };
      let url = item.Codigo == 4 ? "Pedido/EnProceso" : "Pedido/Rechazar";
      service(item.Codigo, url, data);
      return;
    }
  };

  const service = (code, url, data) => {
    console.log("url ",url);
    Axios.post(url, data)
      .then((res) => {
        console.log("respuesta del servidor ",res.data);
        getOrders();
        if (code == 1) {
          toast.notify("El pedido fue despachado");
        } else if (code == 3) {
          toast.notify("El pedido fue rechazado");
        } else if (code == 4) {
          toast.notify("El pedido esta en proceso");
        }
        getStates(code);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const refuse = (data) => {
    Axios.post("Pedido/EnProceso", data)
      .then((res) => {
        console.log(res.data);
        getOrders();
        toast.notify("El pedido fue rechazado");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        TransitionComponent={Transition}
        maxWidth="xl"
        fullWidth={true}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              margin: "1rem",
            }}
          >
            <Typography
              component="h2"
              variant="h6"
              style={{ color: "#707070", marginRight: "2rem" }}
              noWrap
            >
              Detalle Pedido
            </Typography>
            <Button
              variant="contained"
              color="default"
              startIcon={<PictureAsPdfIcon />}
              onClick={handlePrint}
            >
              Generar Reporte
            </Button>
            <Typography
              component="h2"
              variant="h6"
              style={{
                color: "#707070",
                marginRight: "2rem",
                marginLeft: "5rem",
              }}
              noWrap
            >
              Cambiar Estado
            </Typography>

            <Select
              style={{
                borderRadius: "7px",
                height: "50px",
              }}
              color="#707070"
              options={states}
              labelField="Descripcion"
              valueField="Codigo"
              onChange={(value) => changeState(value[0])}
              values={[state]}
            />
            <div style={{ display: "none" }}>
              <Print
                ref={componentRef}
                data={{
                  details,
                  pedido,
                  total,
                }}
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <TableContainer style={{ maxHeight: 500, width: "100%" }}>
            <Table stickyHeader size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell style={{ minWidth: 180 }}>Descripcion</TableCell>
                  <TableCell style={{ minWidth: 120 }}>Precio</TableCell>
                  <TableCell style={{ minWidth: 140, textAlign: "center" }}>
                    Cantidad
                  </TableCell>
                  <TableCell style={{ minWidth: 120 }}>Sub Total</TableCell>
                  <TableCell style={{ minWidth: 400 }}>Observación</TableCell>
                  {/* <TableCell style={{ minWidth: 180 }}><i class="fas fa-tachometer-alt-slowest    "></i></TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {details &&
                  details.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell>{row.Descripcion}</TableCell>
                      <TableCell>
                        {" "}
                        {"$ " +
                          new Intl.NumberFormat("en", {
                            numberingSystem: "latn",
                            style: "decimal",
                            currency: "COP",
                          }).format(row.Precio)}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {row.Cantidad}
                      </TableCell>
                      <TableCell>
                        {" "}
                        {"$ " +
                          new Intl.NumberFormat("en", {
                            numberingSystem: "latn",
                            style: "decimal",
                            currency: "COP",
                          }).format(row.Precio * row.Cantidad)}
                      </TableCell>
                      <TableCell>
                        {row.Observacion
                          ? row.Observacion
                          : "No hay observaciones"}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            spacing={1}
            direction="row"
            justify="center"
            style={{ margin: "1rem", minHeight: "100px" }}
          ></Grid>
        </DialogActions>
      </Dialog>
      <TableContainer style={{ maxHeight: 470 }}>
        <Table stickyHeader size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Codigo</TableCell>
              <TableCell style={{ minWidth: 180 }}>Fecha</TableCell>
              <TableCell style={{ minWidth: 140 }}>Precio</TableCell>
              <TableCell style={{ minWidth: 180 }}>Observación</TableCell>
              <TableCell style={{ minWidth: 100 }}>Estado</TableCell>
              <TableCell style={{ minWidth: 170 }}>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((row, i) => (
              <TableRow key={i}>
                <TableCell
                  style={{ color: "#2e1156", cursor: "pointer" }}
                  component="th"
                  scope="row"
                >
                  {row.NumeroPedido}
                </TableCell>
                <TableCell>
                  {moment(row.Fecha).format("D-MM-YYYY, h:mm a")}
                </TableCell>
                <TableCell>
                  {" "}
                  {"$ " +
                    new Intl.NumberFormat("en", {
                      numberingSystem: "latn",
                      style: "decimal",
                      currency: "COP",
                    }).format(row.Valor)}
                </TableCell>
                <TableCell>
                  {row.Observacion ? row.Observacion : "No hay observaciones"}
                </TableCell>
                <TableCell>{row.Descripcion}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="default"
                    startIcon={<UpdateOutlinedIcon />}
                    onClick={() => getOrdersDetails(row)}
                  >
                    Gestionar Pedido
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
